// extracted by mini-css-extract-plugin
export default {"home":"dashboard_home__OgRoY","additional":"dashboard_additional__5Odxl","linkButton":"dashboard_linkButton__qenBw"};